const config = {
	SERVICE_KEY: process.env.REACT_APP_SERVICE,
	USER_KEY: process.env.REACT_APP_USER,
	TEMPLATE_KEY: process.env.REACT_APP_TEMPLATE,
};
export default config;
